import { locationChangeAction } from '@/domain/router/redux/reduxActions';

// TODO(location-lag): this is the store's own subscription to the router, separate from
// RouterProvider's. On React 17 an update made outside a React event (browser back/forward,
// navigate() after an await) renders once per subscriber, so a page the router renders first sees
// the previous location in the store for one render; clicks are batched by React and unaffected.
// Readers that capture the location at mount keep the stale value — grep TODO(location-lag).
// A fix needs both updates in one render (one batched subscription on React 17; on React 18
// automatic batching covers back/forward, not a navigation after an await), or no store copy at
// all. Moving single components to the router's hooks is not a fix: a component that reads the
// URL from the router and permissions from the store disagrees with itself for that render.
const initLocationChangeListener = (router, dispatch) => () => {
  router.subscribe((state) => {
    const { historyAction, location } = state;

    dispatch(locationChangeAction(location, historyAction));
  });
};

export default initLocationChangeListener;
